import { createFileRoute } from "@tanstack/react-router"

import { EnvInspectorPage } from "@/pages/EnvInspectorPage"

export const Route = createFileRoute("/_admin/env")({
  component: EnvInspectorPage,
})
